/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import users from './users'
import tour from './tour'
import blog from './blog'
import order from './order'
import banner from './banner'
import zaercard from './zaercard'

// Array of sections
export default [...users, ...order, ...tour, ...blog, ...banner, ...zaercard]
